import { render, staticRenderFns } from "./pubRoast.vue?vue&type=template&id=703da45e&scoped=true&"
import script from "./pubRoast.vue?vue&type=script&lang=js&"
export * from "./pubRoast.vue?vue&type=script&lang=js&"
import style0 from "./pubRoast.vue?vue&type=style&index=0&id=703da45e&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703da45e",
  null
  
)

export default component.exports